import React from "react";
import css from "./List.module.scss";

export interface ListProps {
  items: string[];
}

const List: React.FC<ListProps> = ({ items }) => {
  const attrs = {
    list: {
      className: css.list,
    },
  };

  const renderListItems = () => items.map((item, index) => <li key={index}>{item}</li>);

  return <ul {...attrs.list}>{renderListItems()}</ul>;
};

export default List;
